import React from 'react';
import poweredByLogo from '/assets/images/logos/assistme-logo.svg';
import { Flex, Text } from '@chakra-ui/react';
import './PoweredBy.scss';
import { useTranslation } from 'react-i18next';

const PoweredBy: React.FC = () => {
  const { t } = useTranslation();
  return (
    <div className="powered-by">
      <Flex alignItems="center">
        <Text fontSize="xs">{t('poweredBy')}</Text>
        <img src={poweredByLogo} alt="Powered by AssistMe" />
      </Flex>
    </div>
  );
};

export default PoweredBy;
